// assets
import {
  DashboardOutlined,
  CalendarOutlined,
  BarChartOutlined,
  MessageOutlined,
  UserOutlined,
  SettingOutlined
} from '@ant-design/icons';
import Users from '../components/ui/users';
import Plan from '../components/ui/plan';
import ApiIcon from '../components/ui/ApiIcon';
import AllIcon from '../components/ui/AllIcon';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// import { YouTube as  } from '@mui/icons-material';

// icons
const icons = {
  DashboardOutlined,
  CalendarOutlined,
  BarChartOutlined,
  MessageOutlined,
  UserOutlined,
  SettingOutlined,
  Users,
  Plan,
  AllIcon,
  Instagram: InstagramIcon,
  YouTube: YouTubeIcon,
  Facebook: FacebookIcon,
  LinkedIn: LinkedInIcon
};

// ==============================|| APP MENU ||============================== //

const appMenu = {
  id: 'app',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined
    },
{
  id: 'schedule-posts',
  title: 'Schedule Posts',
  type: 'item',
  url: '',
  icon: icons.CalendarOutlined,
  badge: { className: 'right badge badge-danger', text: 'New' },
  children: [
    { id: 'all', title: 'All', type: 'item', url: '/schedule-posts', icon: icons.AllIcon },
    { id: 'instagram', title: 'Instagram', type: 'item', url: '/schedule-posts/instagram', icon: icons.Instagram },
    { id: 'youtube', title: 'YouTube', type: 'item', url: '/schedule-posts/youtube', icon: icons.YouTube },
    { id: 'facebook', title: 'Facebook', type: 'item', url: '/schedule-posts/facebook', icon: icons.Facebook },
    { id: 'linkedin', title: 'LinkedIn', type: 'item', url: '/schedule-posts/linkedin', icon: icons.LinkedIn }
  ]
},

    // {
    //   id: 'analytics',
    //   title: 'Analytics',
    //   type: 'item',
    //   url: '/analytics',
    //   icon: icons.BarChartOutlined
    // },
    {
      id: 'messages',
      title: 'Messages',
      type: 'item',
      url: '/messages',
      icon: icons.MessageOutlined
    },
    {
      id: 'accounts',
      title: 'Accounts',
      type: 'item',
      url: '/account',
      icon: icons.UserOutlined
    },
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.Users
    },
    {
      id: 'plans',
      title: 'Plans',
      type: 'item',
      url: '/plans',
      icon: icons.Plan
    },
    {
      id: 'platform',
      title: 'API Credentials',
      type: 'item',
      url: '/platform',
      icon: ApiIcon
    },

  ]
};

export default appMenu;
